import { uiSurface } from "shared/ui/uiSurface"
import { keyframes } from "@emotion/react"
import { Box, Container, Typography } from "@mui/material"
import { t } from "i18next"
import { FC } from "react"

const pulse = keyframes`
  0%, 100% { transform: scale(1); opacity: 0.6; }
  50% { transform: scale(1.1); opacity: 1; }
`

const shimmer = keyframes`
  0% { background-position: -200% 0; }
  100% { background-position: 200% 0; }
`

const LoadingPage: FC = () => {
  return (
    <Container
      {...uiSurface("UI-DSP-002")}
      data-testid="loading-page"
      maxWidth="md"
      sx={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        height: "100vh",
        textAlign: "center",
      }}
    >
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          mb: 3,
          position: "relative",
        }}
      >
        {/* Animated dots */}
        {[0, 1, 2].map((i) => (
          <Box
            key={i}
            data-testid={`loading-dot-${i}`}
            sx={(theme) => ({
              width: 12,
              height: 12,
              borderRadius: "50%",
              backgroundColor: theme.palette.primary.main,
              mx: 0.5,
              animation: `${pulse} 1.2s ease-in-out infinite`,
              animationDelay: `${i * 0.2}s`,
            })}
          />
        ))}
      </Box>
      <Typography
        variant="h3"
        component="div"
        sx={(theme) => ({
          fontWeight: 700,
          color: theme.palette.text.primary,
          mb: 0.5,
        })}
      >
        {`${t("appLoading")}...`}
      </Typography>
      <Typography
        variant="body2"
        sx={(theme) => ({
          color: theme.palette.text.secondary,
          background: `linear-gradient(90deg, ${theme.palette.text.secondary} 25%, ${theme.palette.primary.main} 50%, ${theme.palette.text.secondary} 75%)`,
          backgroundSize: "200% auto",
          WebkitBackgroundClip: "text",
          WebkitTextFillColor: "transparent",
          backgroundClip: "text",
          animation: `${shimmer} 3s linear infinite`,
        })}
      >
        {t("waitWhileLoading")}
      </Typography>
    </Container>
  )
}

export default LoadingPage
